<template>
  <div class="container">
    <div class="header_title">
      <h1 data-aos="fade-up" data-aos-duration="800">Why Choose</h1>
      <h1 data-aos="fade-up" data-aos-duration="1000">DENTRION?</h1>
    </div>
    <!-- quality -->
    <div class="quality_container">
      <div class="sub_title">01. Quality</div>
      <div class="main_text">
        <p>Exceptional Fit,</p>
        <p>Unmatched Quality</p>
      </div>
      <div class="sub_text">
        <p>Meticulously crafted using cutting-edge</p>
        <p>CAD/CAM & 3D printing technology</p>
        <p>with skilled technicians' expertise.</p>
      </div>
      <div class="carousel_container">
        <div class="carousel" @touchstart="handleSwipe" @mousedown="handleMouseSwipe">
          <div
            class="carousel_inner"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          >
            <div
              v-for="(image, idx) in sliderImages"
              :key="idx"
              class="carousel_item"
            >
              <img :src="image" alt="" class="carousel_image" />
            </div>
          </div>
          <div class="pagination_container">
            <div
              class="pagination_bar"
              :style="{
                width: `${100 / sliderImages.length}%`,
                transform: `translateX(${currentSlide * 100}%)`,
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- value -->
    <div class="value_container">
      <p class="sub_title">02. Value</p>
      <div class="main_text">
        <p>Competitive Pricing</p>
      </div>
      <div class="sub_text">
        <p>Premium prosthetics made with</p>
        <p>top-quality materials at affordable prices</p>
        <p><span class="highlight">53% lower</span> than US alternatives.</p>
      </div>
      <div class="pricing_table">
        <!-- Header -->
        <div class="pricing_row">
          <div class="col_name"></div>
          <div class="col_local" style="font-size: 14px;">Local</div>
          <div class="col_dentrion" style="font-size: 14px;">DENTRION</div>
        </div>
        <!-- Rows -->
        <div class="pricing_row">
          <div class="col_name">Zirconia Crown</div>
          <div class="col_local">$152</div>
          <div class="col_dentrion">$75</div>
        </div>
        <div class="pricing_row">
          <div class="col_name">Implant Crown</div>
          <div class="col_local">$359</div>
          <div class="col_dentrion">$110</div>
        </div>
        <div class="pricing_row">
          <div class="col_name">All on X</div>
          <div class="col_local">$4,191</div>
          <div class="col_dentrion">$2,500</div>
        </div>
      </div>
      <div class="pricing_note">
        <p>*Prices exclude applicable taxes, duties and shipping.</p>
        <p>*Taxes and import duties may vary depending on destination country.</p>
      </div>
    </div>

    <!-- Solution -->
    <div class="solution_container">
      <p class="sub_title">03. Solutions</p>
      <div>
        <div class="main_text">
          <p>Simple Ordering!</p>
        </div>
        <div class="sub_text">
          <p>User-friendly ordering system</p>
          <p>Anyone can navigate.</p>
        </div>
        <div class="solutions_movie">
          <div class="backgound_video">
            <video autoplay muted loop playsinline>
              <source src="../assets/video/01_주문.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <div>
        <div class="main_text">
          <p>Comprehensive Data Tracking!</p>
        </div>
        <div class="sub_text">
          <p>Track the status of your prosthetics</p>
          <p>requests at a glance.</p>
        </div>
        <div class="solutions_movie">
          <div class="backgound_video">
            <video autoplay muted loop playsinline>
              <source src="../assets/video/02_배송.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div>
        <div class="main_text">
          <p>Hassle-Free Payment!</p>
        </div>
        <div class="sub_text">
          <p>Received our services?</p>
          <p>Pay with ease!</p>
        </div>
        <div class="solutions_movie">
          <div class="backgound_video">
            <video autoplay muted loop playsinline>
              <source src="../assets/video/03_카드.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sliderImages: [
        require("../assets/image/slider4_01.svg"),
        require("../assets/image/slider4_02.svg"),
        require("../assets/image/slider4_03.svg"),
        require("../assets/image/slider4_04.svg"),
        require("../assets/image/slider4_05.svg"),
        require("../assets/image/slider4_06.svg"),
      ],
      currentSlide: 0,
      touchStartX: 0,
      touchStartY: 0,
      touchOffset: 0,
    };
  },
  methods: {
    goToSlide(index) {
      this.currentSlide = index;
      this.touchOffset = 0;
    },
    handleSwipe(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;

      const touchMoveHandler = (moveEvent) => {
        const touchMoveX = moveEvent.touches[0].clientX;
        const touchMoveY = moveEvent.touches[0].clientY;
        const diffX = touchMoveX - this.touchStartX;
        const diffY = touchMoveY - this.touchStartY;

        // Check if swipe is horizontal
        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (moveEvent.cancelable) {
            moveEvent.preventDefault(); // Prevent vertical scrolling
          }
        }

        this.touchOffset = diffX;
        const translateX = `translateX(calc(-${this.currentSlide * 100}% + ${
          this.touchOffset
        }px))`;
        document.querySelector(".carousel_inner").style.transform = translateX;
      };

      const touchEndHandler = () => {
        const swipeDistance = this.touchOffset;
        const threshold = 50;

        if (swipeDistance > threshold && this.currentSlide > 0) {
          this.currentSlide--;
        } else if (
          swipeDistance < -threshold &&
          this.currentSlide < this.sliderImages.length - 1
        ) {
          this.currentSlide++;
        }

        this.touchOffset = 0;
        document.querySelector(
          ".carousel_inner"
        ).style.transform = `translateX(-${this.currentSlide * 100}%)`;

        document.removeEventListener("touchmove", touchMoveHandler);
        document.removeEventListener("touchend", touchEndHandler);
      };

      document.addEventListener("touchmove", touchMoveHandler, { passive: false });
      document.addEventListener("touchend", touchEndHandler);
    },
    handleMouseSwipe(event) {
      event.preventDefault(); // 기본 드래그 동작 방지
      this.touchStartX = event.clientX;
      this.touchStartY = event.clientY;

      const mouseMoveHandler = (moveEvent) => {
        const diffX = moveEvent.clientX - this.touchStartX;
        this.touchOffset = diffX;
        const translateX = `translateX(calc(-${this.currentSlide * 100}% + ${
          this.touchOffset
        }px))`;
        
        // 현재 컴포넌트 내부의 요소를 선택
        const carouselInner = this.$el.querySelector(".carousel_inner");
        if (carouselInner) {
          carouselInner.style.transform = translateX;
        }
      };

      const mouseUpHandler = () => {
        const swipeDistance = this.touchOffset;
        const threshold = 50;

        if (swipeDistance > threshold && this.currentSlide > 0) {
          this.currentSlide--;
        } else if (
          swipeDistance < -threshold &&
          this.currentSlide < this.sliderImages.length - 1
        ) {
          this.currentSlide++;
        }

        this.touchOffset = 0;
        
        const carouselInner = this.$el.querySelector(".carousel_inner");
        if (carouselInner) {
          carouselInner.style.transform = `translateX(-${this.currentSlide * 100}%)`;
        }

        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
        document.removeEventListener("mouseleave", mouseUpHandler);
      };

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
      document.addEventListener("mouseleave", mouseUpHandler);
    },
  },
};
</script>
<style scoped>
h1 {
  margin: 0;
}
.container {
  height: 100%;
  padding-top: 60px;
  background-color: #000000;
  color: #ffffff;
}
.header_title > h1 {
  font-weight: 900;
  line-height: 1.1;
  font-size: 32px;
  padding: 0 32px;
  color: #ffffff;
}
.quality_container {
  padding: 0 32px;
  margin-top: 40px;
}
.value_container{
  padding: 0 32px;
  margin-top: 80px;
}

.solution_container {
  padding: 80px 32px 60px 32px;
}

.sub_title {
  font-size: 16px;
  font-weight: 500;
  border-radius: 32px;
  border: 1px solid #FFF;
  padding: 2px 10px;
  display: inline-block;
}
.main_text {
  margin: 18px 0 10px 0;
  font-weight: 900;
  font-size: 24px;
}
.sub_text {
  font-size: 18px;
  color: #fff; /* Light grey */
  line-height: 1.2;
}

.carousel_container {
  width: 100%;
  margin-top: 40px;
}

.carousel {
  width: 100%;
  height: auto; /* 높이 자동 조절 또는 적절한 고정 높이 */
  position: relative;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.carousel_inner {
  display: flex;
  height: 300px; /* 이미지 영역 높이 */
  transition: transform 0.3s ease;
  width: 100%;
}
.pricing_note{
  margin-top: 16px;
  font-size: 11px;
  color: #7C7C7C;
}

.carousel_item {
  flex: 0 0 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.carousel_image {
  height: 100%;
  max-width: 100%;
}

.pagination_container {
  width: 80%;
  margin: 0 auto;
  height: 2px;
  background-color: #a3a3a3;
  position: relative;
  border-radius: 2px;
  overflow: hidden;
}

.pagination_bar {
  height: 100%;
  background-color: #fff;
  transition: transform 0.3s ease;
}
/* Pricing Table Styles */
.highlight {
  color: #51c37e;
  font-weight: 700;
}

.pricing_table {
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}


.pricing_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0 10px;
  font-size: 18px;
  font-weight: 500;
  height: 40px;
}

.col_name {
  flex: 1;
  text-align: center;
  color: white;
  font-weight: 400;
  white-space: nowrap;
  font-size: 14px;
}

.col_local {
  flex: 1;
  text-align: center;
  color: white;
  font-size: 16px;
}

.col_dentrion {
  width: 120px;
  text-align: center;
  color: #51c37e;
  font-weight: 500;
  font-size: 24px;
}

/* Header specific overrides */
.pricing_header .col_dentrion {
  color: #51c37e;
  font-size: 16px;
  font-weight: 500;
}
.pricing_header .col_local {
  color: #b0b0b0;
}
.solutions_movie {
  height: 100%;
  margin-top: 24px;
}
.backgound_video {
  width: 100%;
  margin-bottom: 20px;
}
.backgound_video > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.backgound_video > video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
</style>
